export class CreateConfirmation {
  message: string;
  title?: string;
  okOnly?: boolean;
  subText?: string;
  showTitle: boolean;
  confluenceUrl?: string;
}